import { TrackingPayload } from "./tracking-payload.interface";

export class CompleteRegistrationPayload implements TrackingPayload {
    constructor(
        public status: "success" | "failed",
    ) { }
    public toMetaFormat(): Record<string, any> {
        return {
            status: this.status,
        };
    }
}